{
  "ACTIONS": {
    "CONFIRM": "Confirm",
    "CONTINUE": "Continuă",
    "SUBMIT": "Submit",
    "RETRY": "Reîncearcă",
    "CANCEL": "Cancel",
    "EMPTY": "You have no orders",
    "LOADING_ORDERS": "Se pregătește nota de plată",
    "CLEAR_ALL": "Clear All",
    "AWESOME": "Awesome!",
    "VIEW_RECEIPT": "The Receipt",
    "ADD_CART": "Add to Cart",
    "UPDATE_CART": "Update Cart",
    "EDIT": "Edit",
    "SEARCH_PLACEHOLDER": "Search for food or restaurants"
  },
  "COMMON": {
    "CALORIES": "Cal. {{calories}}",
    "MISSING_SELECTIONS": "Some options are missing, please select before proceeding",
    "ITEM_UNAVAILABLE": "This item is currently not available",
    "SECTION_NOT_FOUND": "Această secțiune nu mai este disponibilă",
    "ITEM_NOT_FOUND": "Acest articol nu mai este disponibil",
    "PROMOTION_NOT_AVAILABLE": "Această promoție nu mai este disponibilă",
    "REQUIRED": "Required",
    "COMBO": "Combo",
    "INVALID_EMAIL": "Vă rugăm să introduceți o adresă de e-mail validă",
    "INVALID_PHONE": "Vă rugăm să introduceți un număr de telefon valid",
    "FEES": "Fees",
    "MIN_ORDER_ERROR": "Minimum order value of {{currency}} {{amount}} is required to place your order",
    "ADD_MIN_ORDER": "Add {{currency}} {{amount}} to place your order",
    "CONNECTION_ERROR": "A apărut o eroare la încărcarea acestei mese. Vă rugăm să încercați din nou.",
    "TABLE_NOT_FOUND": "Nu am găsit această masă. Vă rugăm să scanați din nou codul QR."
  },
  "LANGUAGES": {
    "EN": "English",
    "AR": "عربي",
    "FA": "فارسي",
    "HI": "हिन्दी",
    "RU": "русский",
    "DE": "Deutsch",
    "FR": "Français",
    "TH": "ไทย",
    "EL": "Ελληνικά",
    "CNR": "Crnogorski",
    "ZH-HANS": "中文",
    "RO": "Română",
    "HU": "Magyar",
    "BG": "български",
    "TR": "Türkçe",
    "ES": "Español"
  },
  "BILL": {
    "NAME": "Last Name",
    "ROOM_NUMBER": "Room Number",
    "SNACKBAR_TITLE": "Your bill is on the way",
    "PAY_BILL": "Pay bill"
  },
  "PAY_AT_TABLE": {
    "TOTAL_PEOPLE": "Total persoane la masă",
    "PAYING_FOR": "Total persoane pentru care plătiți",
    "REMAINING": "Suma rămasă",
    "CHEQUE": "Nota de plată",
    "AMOUNT_PAID": "Suma plătită",
    "DISCOUNT": "Reducere",
    "PROMO": "Promo",
    "FEES": "Taxe suplimentare",
    "PAID_ITEMS": "Articole plătite",
    "SPLIT_BILL": "Împarte nota",
    "EDIT_SPLIT": "Editează împărțirea",
    "PAY_BILL": "Plătește nota",
    "SPLIT_TITLE": "Împarte nota de plată",
    "SPLIT_SUBTITLE": "Selectați cum doriți să împărțiți nota",
    "SPLIT_EVENLY": "Împarte egal",
    "CUSTOM_AMOUNT": "Sumă personalizată",
    "ADD_CUSTOM_AMOUNT": "Adaugă sumă personalizată",
    "CUSTOM_AMOUNT_PLACEHOLDER": "Introduceți suma personalizată",
    "PAY_FOR_ITEMS": "Plătiți pentru articolele dvs.",
    "CONFIRM_SELECTION": "Confirmă selecția",
    "SOMEONE_ELSE_PAYING": "Altcineva de la masa dvs. plătește chiar acum"
  },
  "COMBO": {
    "ADD_N": "Adaugă {{count}} {{section}}",
    "REMOVE_N": "Elimină {{count}} {{section}}",
    "CANNOT_PROCEED": "Vă rugăm să urmați ghidul de mai sus pentru a finaliza combo-ul înainte de a continua",
    "COMPLETE": "Combo-ul {{combo}} este complet!",
    "ON_ANOTHER_SECTION": "Aceasta face parte din combo-ul dvs. {{section}}"
  },
  "CART": {
    "TITLE": "Cart",
    "RECOMMENDATION": "You may also like",
    "TOTAL": "Total",
    "VIEW": "View cart & Place order",
    "EMPTY": "Empty",
    "PLACE_ORDER": "Place order",
    "ADD_TO_BILL": "Adaugă la notă",
    "PAY_NOW": "Plătește acum",
    "OOPS": "Oops",
    "ADD_NEW_VARIANT": "Adaugă încă unul",
    "VARIANT_TITLE": "V-ați răzgândit?",
    "ITEM_UPDATED": "An item in your cart has been updated",
    "ITEM_REMOVED": "An item was removed from your cart because it's no longer available",
    "ITEM_LINE": "{{name}}",
    "CONFIRM_CLEAR": "Are you sure you want to clear the cart?",
    "CLEAR": "Clear Cart",
    "ADD_NOTE": "ADD A NOTE",
    "NOTE_LABEL": "Note"
  },
  "PAYMENT": {
    "CONFIRMED": "Your order has been paid !",
    "ERROR": "An error occurred during payment, please try again",
    "APPLE_PAY_TAP_AGAIN": "Please tap Apple Pay again to continue",
    "TITLE": "Plată",
    "PAY_CARD": "Checkout",
    "SUCCESSFUL": "Payment Was Successful",
    "SUMMARY": "Payment Summary",
    "PROGRESS": "Payment in progress..., please wait",
    "CANCEL": "Please do not refresh this page or click on the back button. If you wish to cancel, please press the cancel button on the payment machine."
  },
  "ORDER": {
    "TITLE": "My orders",
    "CONFIRMED": "Confirmed",
    "NOTES": "Order Notes",
    "TOTAL": "Total",
    "SUBTOTAL": "Subtotal",
    "ORDER": "Order",
    "PAID": "Paid",
    "PLACED": "Your Order Has Been Placed",
    "UNPAID": "Comanda dvs. nu este plătită",
    "CANCELLED": "Comanda dvs. a fost anulată",
    "VOID": "Comanda dvs. a fost invalidată",
    "UPDATED": "Comanda dvs. a fost actualizată",
    "ORDERS": "Orders",
    "PREVIOUS": "Previous Orders",
    "REJECTED": "Oops! One or more items or modifiers are currently unavailable and have been removed from your cart."
  },
  "WAITER": {
    "SNACKBAR_TITLE": "We'll be with you shortly",
    "HELP": "How can we help?",
    "ADDITIONAL_COMMENTS": "Comments"
  },
  "MENU": {
    "SKIP": "Omite",
    "MENU": "Menu",
    "SEARCH": "Search",
    "NO_SEARCH_RESULTS": "No items match your search",
    "SEARCH_OTHER_SECTIONS": "We found matches in other sections",
    "NO_FILTER_RESULTS": "No items match your filters",
    "CLEAR_FILTERS": "Clear filters",
    "NO_SECTIONS": "No sections available",
    "STAFF": "Call staff",
    "FILTERS": "Dietery Filters"
  },
  "SETTINGS": {
    "TITLE": "Settings",
    "LANGUAGE": "Language",
    "SELECT_LANGUAGE": "Selectați limba",
    "CURRENCY": "Currency"
  },
  "HOTEL_PREFERENCE": {
    "ROOM": "Charge to my room"
  },
  "RESCAN": {
    "TITLE": "QR",
    "ACTION": "Please rescan the QR to continue your session",
    "SESSION_EXPIRED": "Your session has expired"
  },
  "PICKUP": {
    "TITLE": "Your Details"
  },
  "VOUCHER": {
    "ADD": "Add a Voucher",
    "PLACEHOLDER": "Introduceți voucherul",
    "VOUCHER": "Voucher",
    "DISCOUNTED_AMOUNT": "Total After Discount",
    "CURRENT_BALANCE": "Balance",
    "REMAINING_BALANCE": "Balance After Purchase",
    "AMOUNT_DUE": "Amount Due"
  },
  "TIP": {
    "TIP": "Bacșiș",
    "ADD": "Adaugă bacșiș",
    "PLACEHOLDER": "Introduceți suma bacșișului"
  },
  "LANDING": {
    "CALL_WAITER": "Cheamă ospătarul",
    "VIEW_BILL": "Vezi nota de plată - ",
    "LOADING_BILL": "Se încarcă nota de plată"
  },
  "LOADER": {
    "Heading": "Se procesează plata...",
    "Subheading": "Vă rugăm să nu închideți această pagină. Confirmăm plata și vă vom redirecționa automat.",
    "Hint": "Acest lucru durează de obicei câteva secunde."
  },
  "NoVoucher": "Voucherul nu este disponibil",
  "VoucherDisabled": "Acest voucher este dezactivat",
  "VoucherExpired": "Acest voucher a expirat",
  "VoucherAlreadyUsed": "Acest voucher a fost deja folosit",
  "VoucherZeroBalance": "Acest voucher are un sold de 0",
  "VoucherUserLimitReached": "Ați folosit deja acest voucher",
  "VoucherFirstOrderOnly": "Acest voucher este valabil doar pentru prima dvs. comandă",
  "VoucherNotApplicable": "Acest voucher nu se aplică articolelor din comanda dvs."
}
